export const SET_AUTO_SIGN_OUTS = 'SET_AUTO_SIGN_OUTS'
export const RESET_AUTO_SIGN_OUTS = 'RESET_AUTO_SIGN_OUTS'
